import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteAccidentIssueInput, DeleteAccidentIssueBulkResponse, MutationDeleteAccidentIssueBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteAccidentIssue } from '@/features/AccidentHistory/api/queries/DeleteAccidentIssue';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteAccidentIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteAccidentIssueBulkResponse>;
}

// SearchAccidentIssue Service
export const { deleteAccidentIssue, useDeleteAccidentIssue } = ((): {
  deleteAccidentIssue: ServiceMethod;
  useDeleteAccidentIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteAccidentIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteAccidentIssueInput[], options?: ConnectionOptions): Promise<DeleteAccidentIssueBulkResponse> => {
        const args: MutationDeleteAccidentIssueBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteAccidentIssueBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteAccidentIssueBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteAccidentIssue: fetch,
    useDeleteAccidentIssue: useService,
  };
})();
